import { styled } from '@mui/material';
import { ReactComponent as IconAddNewRule } from '../../../assets/images/addNewRule.svg';

export const StyledIconAddNewRule = styled(IconAddNewRule)(() => ({
  height: '198px',
  width: '198px',
}));
